exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-wide-modal{max-width:95%;width:95%}", ""]);

// exports
